<template>

<div class="columns columns-2 product-meta-price">
	<div class="product-meta">{{ product.product_id }}<br>UPC: {{ product.upc }}</div>
	<div class="product-price" v-html="$formatPrice(product.price)"></div>
</div>

</template>

<script>
export default {
	name: 'product-meta-price',
	props: ['product']
}
</script>
